import {
  GET_ALL_ADS_LANDING,
  GET_ADS_LANDING_REQUEST,
  ADS_LANDING_GET_ERROR,
  ADD_ADS_LANDING,
  ADD_ADS_LANDING_ERROR,
  GET_ADS_LANDING_BY_ID,
  UPDATE_ADS_LANDING_BY_ID,
  UPDATE_ADS_LANDING_ERROR,
  DELETE_ADS_LANDING_BY_ID,
  DELETE_ADS_LANDING_ERROR,
} from "../../constant";

const initialState = {
  adsLandings: null,
  adsLanding: null,
  loading: false,
  error: false,
};

const AdsLandingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADS_LANDING_REQUEST:
      return { ...state, loading: true, error: false };
    case GET_ALL_ADS_LANDING:
      return { ...state, loading: false, adsLandings: action.data };
    case ADS_LANDING_GET_ERROR:
      return { ...state, loading: false, error: true };
    case ADD_ADS_LANDING:
      return { ...state, loading: false, error: false };
    case ADD_ADS_LANDING_ERROR:
      return { ...state, loading: false, error: true };
    case GET_ADS_LANDING_BY_ID:
      return { ...state, loading: false, adsLanding: action.data };
    case UPDATE_ADS_LANDING_BY_ID:
      return { ...state, loading: false, error: false };
    case UPDATE_ADS_LANDING_ERROR:
      return { ...state, loading: false, error: true };
    case DELETE_ADS_LANDING_BY_ID:
      return { ...state, loading: false, error: false };
    case DELETE_ADS_LANDING_ERROR:
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
};

export default AdsLandingReducer;
